import { type ClassValue, clsx } from "clsx";
import { twMerge } from "tailwind-merge";

export function cn(...inputs: ClassValue[]) {
	return twMerge(clsx(inputs));
}

export function formatLocation(location: string | null) {
	if (!location) return "Location TBD";

	// If it's a Google Maps URL, try to extract something meaningful
	if (location.includes("google.com/maps")) {
		// If there's a specific place name in the URL (like a business)
		if (location.includes("/place/")) {
			// Try to extract the place name from the URL
			const placeMatch = location.match(/\/place\/([^\/]+)/);
			if (placeMatch?.[1]) {
				// Decode the URL component and clean it up
				try {
					const decoded = decodeURIComponent(placeMatch[1]);
					// Remove coordinates and other parameters
					const cleanName = decoded.split("+")[0].replace(/\+/g, " ");
					// Filter out any remaining coordinate-like patterns
					if (cleanName.match(/[-+]?\d+\.\d+/) || cleanName.includes("@")) {
						return "Map Location";
					}
					return cleanName;
				} catch (e) {
					return "Map Location";
				}
			}
		}
		return "Map Location";
	}

	// Check for Google Maps short links
	if (
		location.includes("maps.app.goo.gl") ||
		location.includes("goo.gl/maps")
	) {
		return "Map Location";
	}

	// For non-URL locations that are too long, truncate them
	if (location.length > 35) {
		return `${location.substring(0, 32)}...`;
	}

	return location;
}
